module.exports = __webpack_public_path__ + "static/media/nikeSNKRS.9f476fdd.png";